<template>
    <div>
        <b-form-group v-bind="$attrs">
            <template v-if="useLabel" v-slot:label>{{ labelStr }} <span v-if="isRequired" class="required"></span></template>
            <div v-if="isAllowEdit && !isUpdatable">
                <b-form-checkbox :id="groupId" v-model="inputModel" @change="dataChange">{{ labelStr }}</b-form-checkbox>
                <b-form-invalid-feedback :id="feedbackId" :state="state">
                    {{ errorMessage }}
                </b-form-invalid-feedback>
            </div>
            <div :class="useLabel ? 'input-label-detail' : ''" v-else-if="isUpdatable">
                <span>{{ inputModel ? checkedValueStr : uncheckedValueStr }}</span>
                <span class="float-right"><a v-if="isAllowEdit" @click="onPopoverShow" :id="'popover-button-sync-' + groupId"><app-icon-edit /></a></span>
            </div>
            <div v-else>
                <span>{{ inputModel ? checkedValueStr : uncheckedValueStr }}</span>
            </div>
        </b-form-group>
        <b-popover :show.sync="popoverShow" :target="'popover-button-sync-' + groupId" :title="label" placement="bottomleft">
            <b-form-checkbox :id="groupId" v-model="popoverInputModel"></b-form-checkbox>
            <div class="popover-action float-right mt-2 mb-1">
                <b-button @click="popoverShow = false" size="sm" class="btn-default-white">Cancel</b-button>
                <b-button @click="dataPopoverChange" size="sm" class="btn-default ml-2">Save</b-button>
            </div>
        </b-popover>
    </div>
</template>
<script>
export default {
    props: ["model", "id", "errorMessage", "state", "options", "isEditable", "isUpdatable", "change", "label", "isRequired", "nolabel", "checkedValue", "uncheckedValue"],
    data() {
        return {
            labelStr: this.label,
            inputModel:this.model,
            groupId : "fieldset-" + this.id,
            feedbackId : "input-" + this.id + "-live-feedback",
            popoverShow: false,
            popoverInputModel: this.model,
        }
    },
    methods: {
        dataChange() {
            this.$emit('update:model', this.inputModel);
            this.$emit("change");
        },
        dataPopoverChange() {
            this.inputModel = this.popoverInputModel;
            this.$emit('update:model', this.inputModel);
            this.$emit("change");
            this.popoverShow = false;
        },
        onPopoverShow() {
            this.popoverInputModel = this.inputModel;
            this.popoverShow = true;
        },
        inputFormatter(value) {
            return value;
        }
    },
    computed : {
        isAllowEdit : {
            get: function() {
                if (this.isEditable != undefined) return this.isEditable;
                else return true;
            }
        },
        useLabel() {
            if (this.nolabel != null && this.nolabel != undefined && this.nolabel != '') {
                if (this.nolabel) return false;
            }
            return true;
        },
        checkedValueStr() {
            if (this.checkedValue != null && this.checkedValue != undefined && this.checkedValue != '') {
                return this.checkedValue;
            }
            return "Yes";
        },
        uncheckedValueStr() {
            if (this.uncheckedValue != null && this.uncheckedValue != undefined && this.uncheckedValue != '') {
                return this.uncheckedValue;
            }
            return "No";
        },
    },
    watch: {
        model(newValue) {
            this.inputModel = newValue
        }
    }
}
</script>